import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


//custom Components
import Iconset from './icons';
import WifiView from './wifi';

//custom styles
import '../styles/loading_screen.scss';
import '../styles/transition-fadeUp.scss';


class LoadingScreen extends React.Component{

	constructor(props){
		super(props);

		this.state= {
			wifiScreenActive : (localStorage.getItem('wifi-was-visible') != "true"),
			orientation : 0,
			orientationCount : 0,
		}

		if(_assets.isMobile){
			this.addHandler();
		}
	}

	getOrientation(){

		if(window.innerWidth > window.innerHeight){
			this.setState({
				orientation : 1
			});

			if(this.state.orientationCount == 2){
				this.setState({
					orientationCount : 1
				});
			}

		}else{
			this.setState({
				orientation : 0
			});
		}
	}

	addHandler(){
		this.getOrientation();
		window.addEventListener('resize',()=>this.getOrientation());
	}


	componentDidMount(){
		if(_assets.isMobile){
			setTimeout(function(){
				this.setState({
					wifiScreenActive : false,
				});
				localStorage.setItem('wifi-was-visible',true);
			}.bind(this),5000);
		}
	}

	componentWillReceiveProps(nextProps){
		if(_assets.isMobile){
			if(nextProps.firstSession && !nextProps.hasPlayedFirst){
				this.props.goToInnerChapterAfterLoad();
			}
			if(nextProps.firstSession && nextProps.secondSession){
				this.props.goToInnerChapterAfterLoad();
			}
		}else{
			if(nextProps.firstSession && nextProps.secondSession){
				this.props.goToInnerChapterAfterLoad();
			}
		}
	}

	render(){
	
		return (<div className="loading-screen">
			<ReactCSSTransitionGroup
				component= "div"
				className="absolute inner-chapter-holder"
			  transitionName="fade"
			  transitionAppear={true}
     		transitionAppearTimeout={500}
			  transitionEnterTimeout={500}
			  transitionLeaveTimeout={300}>
			  {(_assets.isMobile && this.state.wifiScreenActive) &&
					<WifiView orientation={0}/>
				}
      </ReactCSSTransitionGroup>
			
				<div className="logo-icon">
					<Iconset.logo />
				</div>
				<div className="loading-screen-inner absolute">
					<div className="load-status">
						<div>{this.props.loadStatus}%</div>
						<div className="text-carousel">
							<p className="loading-text-carousel-1">Welcome to Milky Chance&#39;s interactive Blossomentary.</p>
							<p className="loading-text-carousel-2">Hold on a second while we load some videos. Once they&#39;re loaded, we&#39;ll start right away.</p>
							<p className="loading-text-carousel-3">In this interactive experience you&#39;ll discover unknown stories about Clemens and Philipp.</p>
							<p className="loading-text-carousel-4">What brought them together, how they create music and what&#39;s behind their new album BLOSSOM.</p>
							<p className="loading-text-carousel-5">BLOSSOM will be released March 17th and is available for pre-order now.</p>
						</div>
					</div>					
				</div>
			</div>);
	}
}

export default LoadingScreen;


// WEBPACK FOOTER //
// ./src/scripts/loading_screen.js